export const PROTECTED_AREAS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
];
